export default __webpack_public_path__ + "static/media/Vintner-Logo.415607e6.png";